import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BestSpreadsheetArticle from "../pages/articles/BestSpreadsheetArticle";
import ArticlePage from "../pages/articles/ArticlePage";
import About from "../pages/About";
import EditorialPolicy from "../pages/EditorialPolicy";
import PrivacyPolicy from "../pages/PrivacyPolicy";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/best-allchinabuy-spreadsheet",
    element: <BestSpreadsheetArticle />,
  },
  {
    path: "/articles/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/editorial-policy",
    element: <EditorialPolicy />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;